module.exports = __webpack_public_path__ + "static/media/carrot-logo-deep-grey.373352e0.svg";